var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.setTooltip),expression:"setTooltip"}]},[_vm._v(" "+_vm._s(_vm.props.row[_vm.props.column.field])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }